var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 70,
    viewBox: "0 0 66 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 42,
    r: 28,
    fill: "#EEE7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6585 41.7155C30.2429 41.3518 29.6111 41.3939 29.2474 41.8096C28.8837 42.2252 28.9259 42.857 29.3415 43.2207L30.6585 41.7155ZM35.4468 47.234L34.7883 47.9866L35.5148 48.6223L36.1757 47.9187L35.4468 47.234ZM46.7288 36.6847C47.107 36.2821 47.0872 35.6493 46.6847 35.2712C46.2821 34.893 45.6493 34.9128 45.2712 35.3153L46.7288 36.6847ZM29.3415 43.2207L34.7883 47.9866L36.1053 46.4815L30.6585 41.7155L29.3415 43.2207ZM36.1757 47.9187L46.7288 36.6847L45.2712 35.3153L34.718 46.5494L36.1757 47.9187Z",
    fill: "#462980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9897 1.1573C55.7914 2.40962 55.2841 3.59337 54.5142 4.60088C54.2979 4.88405 54.2429 5.25829 54.3753 5.58923C54.5077 5.91997 54.8057 6.15307 55.1575 6.20881C56.4099 6.40709 57.5936 6.91438 58.6011 7.68429C58.8843 7.90067 59.2585 7.95564 59.5895 7.82324C59.9202 7.6908 60.1533 7.39278 60.2091 7.04078C60.4074 5.78846 60.9146 4.60492 61.6845 3.59741C61.9009 3.31424 61.9559 2.93999 61.8235 2.60905C61.6911 2.27832 61.393 2.04522 61.0412 1.98947C59.7889 1.79119 58.6054 1.28393 57.5979 0.514023C57.3147 0.297648 56.9404 0.242671 56.6095 0.375075C56.2786 0.507281 56.0455 0.805307 55.9897 1.1573Z",
    fill: "#FFE5CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01784 59.5926C0.916406 60.2332 0.656906 60.8388 0.263058 61.3542C0.152372 61.499 0.124249 61.6905 0.19198 61.8597C0.259726 62.0289 0.412179 62.1482 0.592142 62.1767C1.23276 62.2781 1.83831 62.5376 2.3537 62.9315C2.49856 63.0422 2.69 63.0703 2.85929 63.0026C3.02848 62.9348 3.14772 62.7824 3.17625 62.6023C3.27768 61.9617 3.53717 61.3562 3.93102 60.8408C4.0417 60.696 4.06983 60.5045 4.0021 60.3352C3.93435 60.1661 3.78189 60.0468 3.60193 60.0183C2.96131 59.9169 2.35587 59.6574 1.84048 59.2635C1.69562 59.1528 1.50418 59.1247 1.33489 59.1925C1.16561 59.2601 1.04637 59.4125 1.01784 59.5926Z",
    fill: "#C9B3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.94aa0b9b6d0051a64483497cad380e21.svg";
export { ForwardRef as ReactComponent };